let templateScopeMeta = {};

export const setTemplateScopeMeta = (id, meta) => {
  if (!id) return;
  templateScopeMeta[id] = meta || {};
};

export const getTemplateScopeMeta = (id) => {
  if (!id) return undefined;
  return templateScopeMeta[id];
};
